(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["group"] && !Shopify.designMode) return;
  try {
    const markMatchedGroupLinks = (root = document) => {
    root.querySelectorAll('.group-block').forEach((group) => {
      const groupLink = group.querySelector(':scope > .group-block__link');
      if (!groupLink) return;

      const groupHref = groupLink.href;
      group.querySelectorAll('.group-block-content a').forEach((link) => {
        link.classList.toggle('group-block__matched-link', link.href === groupHref);
      });
    });
  };

  markMatchedGroupLinks();

  document.addEventListener('shopify:section:load', (event) => {
    markMatchedGroupLinks(event.target);
  });
  } catch(e) { console.error(e); }
})();

})();
